import {
  CarHireItemType,
  ExperienceItemType,
  FlightItemType,
  HotelItemType,
} from '@reward-platform/order-schemas/common'
import { getCancellationPolicies } from '~/services/contentService'
import { useQuery } from '@tanstack/react-query'
import { useLocalisation } from '~/context/localisation'
import { useTranslations } from 'next-intl'
import { useNotification } from '~/context/notification'
import { useEffect } from 'react'
import { GenericClientError } from '~/utils/errors'
import { useContentfulPreviewMode } from '../useContentfulPreviewMode/useContentfulPreviewMode'

export const CANCELLATION_DATE_FORMAT = 'eee, do MMM'

const useCancellationPolicyContent = () => {
  const { locale } = useLocalisation()
  const { addErrorCodeNotification } = useNotification()
  const previewMode = useContentfulPreviewMode()
  const { data, isError, error } = useQuery({
    queryKey: ['cancellationPolicies', locale, previewMode],
    queryFn: () => getCancellationPolicies(locale, previewMode),
  })

  useEffect(() => {
    if (isError && error instanceof GenericClientError) {
      addErrorCodeNotification('CONTENT_CANCELLATION_POLICY_ERROR', {
        type: 'ERROR',
        errorCode: error.code,
        statusCode: error.httpStatus,
      })
    }
  }, [isError, error, addErrorCodeNotification])

  const t = useTranslations('components.cancellation_policy.titles')

  const productCancellationTitles = {
    [HotelItemType]: t('hotel'),
    [CarHireItemType]: t('car_hire'),
    [FlightItemType]: t('flight'),
    [ExperienceItemType]: t('experience'),
    default: t('default'),
  }
  return {
    productCancellationTitles,
    templates: data,
  }
}

export default useCancellationPolicyContent
